module.exports = __WEBPACK_EXTERNAL_MODULE_62__;


//////////////////
// WEBPACK FOOTER
// external {"root":"moment","commonjs2":"moment","commonjs":"moment","amd":"moment"}
// module id = 62
// module chunks = 0